import { useTranslation } from "react-i18next";
import { components } from "react-select";

// Custom option component for part categories with edit functionality
const PartCategoryOption = (props) => {
  const { t } = useTranslation("common");

  const handleEditClick = (e) => {
    e.stopPropagation();
    // Show the popup by setting the data and showing the popup
    if (props.setTempPartCategoryData && props.setShowPartCategoryPopup) {
      props.setTempPartCategoryData({ ...props.data, __isNew__: false });
      props.setShowPartCategoryPopup(true);
    }
  };

  // Handle "create new" option
  if (props.data.__isNew__) {
    return (
      <>
        <hr style={{ margin: 0, padding: 0 }} />
        <components.Option {...props}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <span
              style={{ color: "#007bff", fontWeight: 300, fontSize: "12px" }}
            >
              {t("create_new_part_category")}
              <span style={{ fontWeight: 500 }}> "{props.data.value}"</span>
            </span>
            {/*<i
              className="fi fi-rr-pencil"
              style={{
                cursor: "pointer",
                color: "#6c757d",
                marginLeft: "8px",
                fontSize: "14px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (props.setTempPartCategoryData && props.setShowPartCategoryPopup) {
                  props.setTempPartCategoryData(props.data);
                  props.setShowPartCategoryPopup(true);
                }
              }}
              onMouseEnter={(e) => {
                e.target.style.color = "#495057";
              }}
              onMouseLeave={(e) => {
                e.target.style.color = "#6c757d";
              }}
            />*/}
          </div>
        </components.Option>
      </>
    );
  }

  return (
    <components.Option {...props}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <span style={{ flex: 1 }}>{props.data.label}</span>
        <i
          className="fi fi-rr-pencil"
          style={{
            cursor: "pointer",
            color: "#6c757d",
            marginLeft: "8px",
            fontSize: "14px",
          }}
          onClick={handleEditClick}
          onMouseEnter={(e) => {
            e.target.style.color = "#495057";
          }}
          onMouseLeave={(e) => {
            e.target.style.color = "#6c757d";
          }}
        />
      </div>
    </components.Option>
  );
};

export default PartCategoryOption;
